webpackJsonp([24,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _shared = __webpack_require__(10);
	
	var _shared2 = _interopRequireDefault(_shared);
	
	var _utils = __webpack_require__(3);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _languageManager = __webpack_require__(6);
	
	var _languageManager2 = _interopRequireDefault(_languageManager);
	
	var _loginManager = __webpack_require__(213);
	
	var _loginManager2 = _interopRequireDefault(_loginManager);
	
	var _storageController = __webpack_require__(50);
	
	var _storageController2 = _interopRequireDefault(_storageController);
	
	var _formValidator = __webpack_require__(24);
	
	var _formValidator2 = _interopRequireDefault(_formValidator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 08/05/2017.
	 */
	//js
	var log = __webpack_require__(5)();
	
	
	//Styles
	__webpack_require__(768);
	
	$(function () {
	  _shared2.default.init();
	  LoginPage.init();
	});
	
	var LoginPage = {};
	
	(function (LoginPage) {
	  var $usernameForm = void 0,
	      $loginForm = void 0;
	
	  var emailFormValidator = null;
	  var loginFormValidator = null;
	
	  LoginPage.init = function () {
	    setUpEventListeners();
	    setUpLoginForm();
	
	    $("#page-title").text(_languageManager2.default.getValueForKey("login.page_title"));
	
	    $usernameForm = $("#login-form1");
	    $loginForm = $("#login-form2");
	  };
	
	  function setUpEventListeners() {
	    var _this = this;
	
	    $("#validate-email-btn").off("click").on("click", function (e) {
	      validateUsername();
	    });
	
	    $("#authenticate-btn").on("click", function (e) {
	      var $this = $(this);
	      var isValid = loginFormValidator.validate();
	
	      if (isValid) {
	        $this.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");
	
	        login().finally(function () {
	          $this.prop("disabled", false).removeClass("btn-loading");
	        });
	      }
	    });
	
	    var $usernameInput = $("#login-username-input");
	
	    $usernameInput.off("input").on("input", function (e) {
	      $(this).removeClass("input-error");
	    });
	
	    var $passwordInput = $("#login-password-input");
	
	    $passwordInput.off("input").on("input", function (e) {
	      $(this).removeClass("input-error");
	    });
	
	    $passwordInput.off("keyup").on("keyup", function (e) {
	      if (_utils2.default.isNotNull(e.code) && e.code === "Enter" || e.keyCode === 13) {
	        $(this).blur();
	        login();
	      }
	    });
	
	    $("#login-username1-input").off("keypress").on("keypress", function (e) {
	      if (_utils2.default.isNotNull(e.code) && e.code === "Enter" || e.keyCode === 13) {
	        $(_this).blur();
	        validateUsername();
	      }
	    });
	
	    $("form").off("keypress").on("keypress", function (e) {
	      if (_utils2.default.isNotNull(e.code) && e.code === "Enter" || e.keyCode === 13) {
	        e.preventDefault();
	      }
	    });
	  }
	
	  function setUpLoginForm() {
	    emailFormValidator = new _formValidator2.default({
	      selector: "#login-form1",
	      validateOnChange: true,
	      rules: {
	        username: {
	          validator: function validator(username) {
	            return !_utils2.default.isNullOrEmpty(username) && username.trim() !== "";
	          }
	        }
	      }
	    });
	
	    loginFormValidator = new _formValidator2.default({
	      selector: "#login-form2",
	      validateOnChange: true,
	      rules: {
	        password: {
	          validator: function validator(password) {
	            return !_utils2.default.isNullOrEmpty(password) && password.trim() !== "";
	          }
	        }
	      }
	    });
	  }
	
	  function validateUsername() {
	    var isValid = emailFormValidator.validate();
	
	    if (isValid) {
	      var formData = emailFormValidator.getFormData();
	      var username = formData.username;
	
	      var $validateEmailBtn = $("#validate-email-btn");
	
	      $validateEmailBtn.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");
	
	      var $formFeedback = $usernameForm.find(".form-feedback").empty();
	
	      return _loginManager2.default.usernameExists(username).then(function (data) {
	        log.info("Username [%s] exists ? %o", username, data);
	
	        emailFormValidator.setValid("username", data.data);
	
	        if (data.data) {
	          loginFormValidator.setValueForKey("username", username);
	
	          $usernameForm.removeClass("form-active");
	          $loginForm.addClass("form-active");
	
	          setTimeout(function () {
	            return $("#login-password-input").focus();
	          }, 300);
	        } else {
	          // Username doesn't exist
	          $formFeedback.text(_languageManager2.default.getValueForKey("login.errors.username_not_found"));
	          $("#login-username1-input").focus();
	        }
	      }).catch(function (err) {
	        log.error("Failed to check if username [%s] exists - %o", username, err);
	      }).finally(function () {
	        $validateEmailBtn.prop("disabled", false).removeClass("btn-loading");
	      });
	    }
	  }
	
	  function login() {
	    if (_utils2.default.isNull(loginFormValidator)) return;
	
	    var $formFeedback = $loginForm.find(".form-feedback").empty();
	
	    var formData = loginFormValidator.getFormData();
	
	    var username = formData.username,
	        password = formData.password;
	
	    return _loginManager2.default.login(username, password).then(function (data) {
	      var loginData = data.loginData,
	          referer = data.referer;
	
	      _storageController2.default.saveToLocal(_storageController2.default.keys.LOGGED_IN_USER, loginData);
	
	      log.info("Referer: %s", referer);
	
	      if (!_utils2.default.isNullOrEmpty(referer) && referer.includes("/login")) {
	        _utils2.default.redirect("/teacher/platform");
	      } else {
	        _utils2.default.redirect(referer);
	      }
	    }).catch(function (appError) {
	      log.error("Login failed - %o", appError);
	
	      loginFormValidator.setValid("password", false);
	      $("#login-password-input").focus();
	
	      if (appError.data.errorType === _loginManager2.default.ERRORS.USERNAME_PASSWORD_INCORRECT) {
	        $formFeedback.text(_languageManager2.default.getValueForKey("login.errors.password_incorrect"));
	      } else {
	        $formFeedback.text(_languageManager2.default.getValueForKey("login.errors.unexpected"));
	      }
	    });
	  }
	})(LoginPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 12
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 11;


/***/ }),

/***/ 768:
47

});


// WEBPACK FOOTER //
// js/login.716269f32be02407fb98.js